export const MA_DEAL_GROSS_SYNERGY_BY_BAND_FORMULA_ID =
  'ma_deal_gross_synergy_by_band_v1' as const;
export const MA_DEAL_GROSS_SYNERGY_BY_BAND_FORMULA_VERSION = '1.0.0' as const;
export const MA_DEAL_BANDS = ['conservative', 'base', 'stretch'] as const;

export type MaDealBand = (typeof MA_DEAL_BANDS)[number];

export type MaDealFormulaCommitment = Readonly<{
  commitmentRef: string;
  displayLabel: string;
  targetClaim: Readonly<{
    bands: Readonly<Record<MaDealBand, number>>;
  }>;
}>;

export type MaDealGrossSynergyByBandInput = Readonly<{
  commitments: readonly MaDealFormulaCommitment[];
  band: MaDealBand;
}>;

export type MaDealGrossSynergyByBandOutput = Readonly<{
  band: MaDealBand;
  value: number;
  components: readonly Readonly<{
    key: string;
    label: string;
    value: number;
  }>[];
}>;

export function isMaDealBand(value: unknown): value is MaDealBand {
  return value === 'conservative' || value === 'base' || value === 'stretch';
}

export function calculateMaDealGrossSynergyByBand(
  input: MaDealGrossSynergyByBandInput,
): MaDealGrossSynergyByBandOutput {
  const components = input.commitments.map((commitment) => {
    const bands = commitment.targetClaim.bands;
    assertCoherentBands(bands, commitment.commitmentRef);
    return Object.freeze({
      key: commitment.commitmentRef,
      label: commitment.displayLabel,
      value: bands[input.band],
    });
  });
  return Object.freeze({
    band: input.band,
    value: components.reduce((sum, component) => sum + component.value, 0),
    components: Object.freeze(components),
  });
}

function assertCoherentBands(
  bands: Readonly<Record<MaDealBand, number>>,
  commitmentRef: string,
): void {
  const values = [bands.conservative, bands.base, bands.stretch];
  const invalid = values.some((value) => !Number.isFinite(value) || value < 0);
  if (invalid || !(bands.conservative <= bands.base && bands.base <= bands.stretch)) {
    throw new Error(`coherent_band_violation:${commitmentRef}`);
  }
}
